import { loadConfigurationModule } from '@config/utils';


export const getModules = function(store, config={MODULES: []}) {
  // const modules = { routes: {}, state: {}, locales: {} };
  try {
    // let currentPath = new URL(window.location.href).hash.replace('#','').replace(/^\/|\/$/g, '').split('/')
    // let alias = currentPath.length ? currentPath[0].toLowerCase() : null;
    // .filter(m => m == alias)
    const activeModules = [...['backoffice', 'portal'], ...config.MODULES.map(v => v.toLowerCase())];
    return loadConfigurationModule(store, null, true, activeModules, config);
  }
  catch(err) {
    console.error(err)
  }

  return {state:{}, routes:{}, locales:{}};
};